import {TUser} from "@/types/userTypes";
import {createSlice} from "@reduxjs/toolkit";

export const initialState: {
  user: TUser;
  platformBearer: string | undefined;
} = {
  user: {
    id: "",
    email: "",
    role: "",
    created_at: "",
    updated_at: "",
    dashboard_url: "",
  },
  platformBearer: undefined,
};

export const userSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setPlatformBearer: (state, action) => {
      state.platformBearer = action.payload;
    },
    resetUserState: (state) => {
      state.user = initialState.user;
      state.platformBearer = initialState.platformBearer;
    },
  },
});

export const {setUser, setPlatformBearer, resetUserState} = userSlice.actions;

export default userSlice;
